import type { CSSProperties } from 'react';

/** Shared geometry and theme for chart header actions in every client. */
export const chartToolbarButtonStyle: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  boxSizing: 'border-box',
  width: 30,
  height: 30,
  minHeight: 'unset',
  padding: 0,
  margin: 0,
  border: 'none',
  borderRadius: 9,
  background: 'var(--surface-sunken)',
  boxShadow: 'var(--nm-raised-sm)',
  color: 'var(--fg-3)',
  fontFamily: 'inherit',
  fontSize: 18,
  lineHeight: 1,
  cursor: 'pointer',
};
